module.exports = __webpack_public_path__ + "img/danamas.458df84b.webp";